export const appCdnURL = "https://colectio-dist.fra1.cdn.digitaloceanspaces.com/production/20261008b/"

export const appSpaLoadingTemplate = "nuxt/spa-loading-template.html"

export const appHead = {"meta":[{"charset":"utf-8"},{"http-equiv":"X-UA-Compatible","content":"IE=edge"},{"http-equiv":"Cache-control","content":"no-cache, no-store, must-revalidate"},{"http-equiv":"Pragma","content":"no-cache"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"robots","content":"index, follow"},{"name":"referrer","content":"no-referrer-when-downgrade"},{"name":"Cross-Origin-Opener-Policy","content":"same-origin-allow-popups"},{"name":"apple-mobile-web-app-title","content":"Colectio"},{"name":"theme-color","content":"#ffffff"},{"property":"fb:app_id","content":"2367019320158628"}],"link":[{"rel":"icon","type":"image/png","href":"/favicon/favicon-96x96.png","sizes":"96x96"},{"rel":"icon","type":"image/svg+xml","href":"/favicon/favicon.svg"},{"rel":"shortcut icon","href":"/favicon/favicon.ico"},{"rel":"apple-touch-icon","sizes":"180x180","href":"/favicon/apple-touch-icon.png"},{"rel":"manifest","href":"/favicon/site.webmanifest"},{"rel":"preconnect","href":"https://fonts.googleapis.com"},{"rel":"preconnect","href":"https://fonts.gstatic.com","crossorigin":""},{"rel":"stylesheet","href":"https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap"}],"style":[],"script":[{"innerHTML":"window.dataLayer = window.dataLayer || [];"},{"innerHTML":"(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\nnew Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\nj=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n})(window,document,'script','dataLayer','GTM-5H7ZVGD');"},{"innerHTML":"function gtag(){dataLayer.push(arguments);}\ngtag('js',new Date());\ngtag('config','GTM-5H7ZVGD');\ngtag('consent','default',{\n  'ad_storage':'denied',\n  'ad_user_data':'denied',\n  'ad_personalization':'denied',\n  'analytics_storage':'denied',\n  'functionality_storage':'granted',\n  'personalization_storage':'denied',\n  'security_storage':'denied',\n});"},{"src":"https://accounts.google.com/gsi/client","async":true}],"noscript":[],"htmlAttrs":{"lang":"cs"},"title":"Colectio: Objevuj svět sběratelů"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = {"enabled":false}

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const componentIslandsActive = false

export const payloadExtraction = false

export const prefetchPreloadTags = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const useStateDefaults = {"resetOnClear":false}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false

export const asyncCallHook = true

export const clientNodePlaceholder = false

export const tracingChannelNuxt = false

export const runtimeCompiler = false

export const hasPluginDependencies = false

export const hasParallelPlugins = false

export const hasPluginHooks = false

export const hasIslandOptOutPlugins = false